export let life = {
  created(){
    //整理列
    this.methods('doTableCol',this.tableProp)
  },
  mounted () {
    this.methods('setPropToLabelObj')
    this.methods('getPropToLabel')
    this.$nextTick(() => {
      // 判断是否要显示扩展
      this.methods('autoExpand')
    })
    $(window).on('resize', () => {
      this.methods('autoExpand')
    })
    $(this.$refs.table.$el).on('mousedown', e => {
      if (e.ctrlKey && e.buttons === 1) {
      }
    })
    this.tableAutoHeight = $(this.$refs.TTable).height()
  }
}
export let event = {
  /**
   * 点击某一行，转发element-ui的接口给父组件用
   * @param row 行数据
   * @param event 点击事件对象
   * @param column 列数据
   */
  clickTr (row, event, column) {
    this.methods('clickTr', ...arguments)
  },
  clickTd () {
    this.methods('clickTd', ...arguments)
  },
  handleSelectionChange () {
    this.methods('handleSelectionChange', ...arguments)
  },
  select () {
    this.methods('select', ...arguments)
  },
  selectAll () {
    this.methods('selectAll', ...arguments)
  },
  sortChange () {
    this.methods('sortChange', ...arguments)
  },
  tableRowClassName({row, rowIndex}) {
    if (row.currentColor) {
      return 'current-row-color'
    }
    return ''
  },
  formatEmpty (value) {
    return this.methods('formatEmpty', value)
  },
  flitterData(arr){
    let forceArr = []
    for(var i = 0;i<this.mergeList.length;i++){
      forceArr[i] ={concat:0,rows:[1]}
    }
    arr.forEach((item,index)=>{
      if(index!= 0){  //是看上一项和当前是否一样  如果是0 就没有上一项  这样写不会影响结果
        this.mergeList.forEach((items,idx)=>{
          if(items.isMerge===false){
            for(var m = 0;m<arr.length;m++){
              forceArr[idx].rows.push(1)
            }
          }else{
            if(item[items.prop] === arr[index - 1][items.prop]){ //循环  自动计算需要合并的项以及合并多少
                let curNum = forceArr[idx].concat
                forceArr[idx].rows[curNum]=forceArr[idx].rows[curNum]?forceArr[idx].rows[curNum]:1
                forceArr[idx].rows[curNum]+=1
                forceArr[idx].rows.push(0);
            }else{
                forceArr[idx].rows.push(1)
                forceArr[idx].concat = index   //记录下是列的哪个  下次合并就从这里开始  （上一行）
            };
          }
        })
      }
    });
    return  {
      forceArr:forceArr
    }
  },

  objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      for(let num =0;num<this.mergeList.length;num++){
        if(columnIndex === num ) {
          const _row = (this.flitterData(this.tableData).forceArr[num]).rows[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col
          };
        }
      }
  },
}
export let watch = {
  // 当不可折叠的时候，将那些折叠产生的tr去掉
  currentExpand () {
    if (!this.currentExpand) {
      $(this.$refs.TTable).find('.el-table__expanded-cell').parent().remove()
    }
  },
  // hideLevel发生改变时
  hideLevel () {
    if (this.hideLevel.length > 0) {
      this.currentExpand = true
    } else {
      this.currentExpand = false
    }
  },
  // 当数据改变，需要重新计算最小宽度
  tableData () {
    // if (_.isEmpty(this.tableData))return 管它有没有数据，都要计算
    this.methods('setPropToLabelObj')
    this.$nextTick(() => {
      // 判断是否要显示扩展
      this.methods('autoExpand')
      // 点击第一列
      this.$nextTick(() => {
        $(this.$refs.table.$el).find('tbody tr:eq(0)').trigger('click')
      })
    })
  }
}
